function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2-4h24v24H-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 14h-2V5.2L10 9 4 5.2V14H2V2h1.2L10 6.2 16.8 2H18v12z",
  fill: "#FFF"
}));

function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNLTItNGgyNHYyNEgtMnoiLz48cGF0aCBkPSJNMTggMEgyQy45IDAgMCAuOSAwIDJ2MTJjMCAxLjEuOSAyIDIgMmgxNmMxLjEgMCAyLS45IDItMlYyYzAtMS4xLS45LTItMi0yem0wIDE0aC0yVjUuMkwxMCA5IDQgNS4yVjE0SDJWMmgxLjJMMTAgNi4yIDE2LjggMkgxOHYxMnoiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+";
export { SvgIconEmail as ReactComponent };